import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//models

//services

//component
import { AuthenticatedComponent} from "../../../../../shared/components/AuthenticatedComponent";
import {number} from "ng2-validation/dist/number";
import {MenuItemService} from "../../../../services/menu.service";
import {BsModalRef} from "ngx-bootstrap";
@Component({
	selector: 'app-section-modal',
	templateUrl: './importOptions-modal.component.html',
	styleUrls: ['./importOptions-modal.component.scss']
})

export class ImportOptionsModalComponent extends AuthenticatedComponent implements OnInit {

	constructor(public menuItemService:MenuItemService,public bsModalRef:BsModalRef){
		super();
	}
  @Input() menuItemId: number;
  file:any = null;
  clicked: boolean=false;
	ngOnInit() {

	}
  public import()
  {
    this.menuItemService.Import(this.file,this.menuItemId).subscribe(data=>
    {
      this.clicked=false;
      if (!data.hasError)
      {
        this.alertService.showSuccess(this.translate.instant("alerts.IMPORTEDSUCCESSFULLY"));
        this.bsModalRef.hide();
      }
      else{
        let errors = data.errors.map(r => {return r.message});
        this.alertService.showError(errors);
      }
    })
  }
}
